import React from 'react';
import { Text, Group, Circle } from 'react-konva';

export default function CanvasCursors({ cursors, currentUserId }) {
  return (
    <>
      {Object.entries(cursors || {}).map(([userId, cursor]) => {
        // Don't show own cursor
        if (userId === currentUserId) return null;
        
        return (
          <Group key={userId} x={cursor.x} y={cursor.y}>
            {/* Cursor pointer */}
            <Circle
              radius={5}
              fill={cursor.color || '#3B82F6'}
              opacity={0.8}
            />
            {/* User name label */}
            <Group x={10} y={10}>
              <Text
                text={cursor.user_name || 'Anonymous'}
                fontSize={11}
                fontFamily="Inter, system-ui, sans-serif"
                fill="#FFFFFF"
                padding={4}
                offsetY={-2}
              />
              {/* Background for text */}
              <Text
                text={cursor.user_name || 'Anonymous'}
                fontSize={11}
                fontFamily="Inter, system-ui, sans-serif"
                fill={cursor.color || '#3B82F6'}
                padding={4}
                offsetY={-2}
                visible={false}
              />
            </Group>
          </Group>
        );
      })}
    </>
  );
}
